// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"8da1e33c","301":"8ba471b2","314":"30d97438","343":"b2f9f068","386":"319950ab","476":"d3ff4edb","510":"f7fc50df","551":"a924b201","582":"b5a17b25","872":"9424fcf8","912":"f00c69e5","987":"4b43c267"}[chunkId] + ".chunk.js";
};